export const HELP_VIDEO_LINKS: Record<string, string> = {
  "components.metriccard.metriccard.1": "",
  "pages.whatsapp-automation": "",
  "pages.store-groups": "",
  "pages.cashflow.cashflow.1": "",
  "pages.cashflow.cashflow.2": "",
  "pages.cashflow.cashflow.3": "",
  "pages.cashflow.employeemetricspage.1": "",
  "pages.cashflow.payrollsummarypage.1": "",
  "pages.delivery.courierpartnerspage.1": "https://youtu.be/sMJwrAcsbAY",
  "pages.delivery.courierpartnerspage.2": "https://youtu.be/sMJwrAcsbAY",
  "pages.delivery.pupop.courierpaymentpupop.1": "https://youtu.be/sMJwrAcsbAY", //pagamento do entregador
  "pages.delivery.pupop.createcourierpupop.1": "https://youtu.be/sMJwrAcsbAY", //Linkar um criar um entregador
  "pages.delivery.pupop.linkcourierpupop.1": "https://youtu.be/sMJwrAcsbAY", //Linkar um entregador
  "pages.fluxo.customer.customerpopup.1": "https://youtu.be/AtqaZL7LyOk",
  "pages.fluxo.customer.customerpopup.2": "https://youtu.be/a3aYKYqIWbU",
  "pages.fluxo.order.detailspaymentpupop.1": "",
  "pages.fluxo.order.detailspaymentpupop.2": "",
  "pages.fluxo.order.orderpupopclose.1": "",
  "pages.fluxo.tables.tablespupop.1": "https://youtu.be/UJi-_4R6Zic",
  "pages.myrestaurant.employees.components.employeepermissions.1": "https://youtu.be/nG8_DYI_7lM",
  "pages.myrestaurant.employees.employeepupop.1": "https://youtu.be/nG8_DYI_7lM",
  "pages.myrestaurant.employees.employeepupop.2": "https://youtu.be/nG8_DYI_7lM",
  "pages.myrestaurant.employees.employeepupop.3": "https://youtu.be/nG8_DYI_7lM",
  "pages.myrestaurant.mycompany.billingpopup.1": "https://youtu.be/5QBVFTgoHf4",
  "pages.myrestaurant.mycompany.companyaddresspupop.1": "https://youtu.be/TNxoMU3vwfk",
  "pages.myrestaurant.mycompany.companydatapupop.1": "https://youtu.be/-Uvf1tDOQB4",
  "pages.myrestaurant.mycompany.freeshippingsettingspupop.1": "https://youtu.be/fiefjEUgC2Q",
  "pages.myrestaurant.mycompany.linkpublicmenupupop.1": "https://youtu.be/yBJpQRCd-2I",
  "pages.myrestaurant.mycompany.marketingtrackingpopup.1": "",
  "pages.myrestaurant.mycompany.metaintegrationpopup.1": "https://youtu.be/oJfNA0SoXKI",
  "pages.myrestaurant.mycompany.metaintegrationpopup.2": "https://youtu.be/oJfNA0SoXKI",
  "pages.myrestaurant.mycompany.metaphoneregistrationpopup.1": "",
  "pages.myrestaurant.mycompany.metatestpopup.1": "",
  "pages.myrestaurant.mycompany.operatingschedulepopup.1": "https://youtu.be/yYGQ2cQ7J4U",
  "pages.myrestaurant.mycompany.planpopup.1": "", //planos
  "pages.myrestaurant.mycompany.publicmenucustomizationpopup.1": "https://youtu.be/anD8HQ0yrWM",
  "pages.myrestaurant.mycompany.publicmenuqrcodepupop.1": "https://youtu.be/t7f67yIHESM",
  "pages.myrestaurant.mycompany.socialmediapupop.1": "https://youtu.be/KBH-4ovjJEI",
  "pages.myrestaurant.mycompany.vacationsettingspopup.1": "https://youtu.be/uRCPG0hD8w4",
  "pages.myrestaurant.mycompany.whatsappordersupportpopup.1": "https://youtu.be/JVUsnpjcXwo",
  "pages.products.addtional.addtionalpupop.1": "https://youtu.be/iymKx938cBo",
  "pages.products.category.categorypupop.1": "https://youtu.be/IiMUX_ec6M8",
  "pages.products.category.categoryorderpopup.1": "https://youtu.be/IiMUX_ec6M8",
  "pages.products.combo.combopopup.1": "https://youtu.be/hnqmpcol7hg",
  "pages.products.drinks.drinkspupop.1": "https://youtu.be/v1-DNt9zN7k",
  "pages.products.genericfoodpupop.1": "", //tags das comidas/bebidas
  "pages.products.genericfoodpupop.2": "https://youtu.be/_3Tlf-csB_w",
  "pages.products.genericfoodpupop.3": "https://youtu.be/iymKx938cBo",
  "pages.products.genericfoodpupop.4": "https://youtu.be/iymKx938cBo",
  "pages.products.genericfoodpupop.5": "https://youtu.be/iMKo54tXq_s",
  "pages.products.meals.mealspupop.1": "https://youtu.be/IR9bvpJUSLw",
  "pages.products.selection.selectionpupop.1": "https://youtu.be/_3Tlf-csB_w",
  "pages.products.selection.selectionpupop.2": "https://youtu.be/_3Tlf-csB_w",
  "pages.reseller.editresellerprofilepopup.1": "",
  "pages.reseller.completeresellerprofilepopup.1": "",
  "pages.reseller.requestresellercouponpopup.1": "",
  "pages.serivesdir.awards.awardpupop.1": "https://youtu.be/a3aYKYqIWbU",
  "pages.serivesdir.coupons.couponspupop.1": "https://youtu.be/VkFNTaROpvw",
  "pages.serivesdir.extraservices.extraservicepupop.1": "https://youtu.be/PPeB9dlS7Ww",
  "pages.serivesdir.notices.noticepopup.1": "https://youtu.be/pKvA8OtpVS8",
  "pages.serivesdir.promotions.promotionspupop.1": "https://youtu.be/iMKo54tXq_s",
  "pages.serivesdir.promotions.promotionspupop.2": "", //Aplicar promoção
  "pages.serivesdir.promotions.promotionspupop.3": "", //Remover promoção
  "pages.shared.associations.1": "",
}

export const getHelpVideoLink = (helpKey?: string): string => {
  if (!helpKey) {
    return ""
  }

  return HELP_VIDEO_LINKS[helpKey] ?? ""
}
